// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export class Car
{
  public id: string;
  public category: string;
  public make: string;
  public model: string;
  public body: string;
  public variant: string;
  public wheelbase: string;
  public height: string;
  public dimensions: string;
  public loadingSpace: string;
  public wheelLayout: string;
  public transmission: string;
  public reference: string;
  public exceptions: string;
  public exceptions2: string;
  public modelAccess: string;
  public status: string;
  public display: string;
}
